/**
 * Generated by orval v7.9.0 🍺
 * Do not edit manually.
 * Meeting BaaS API
 * API for managing meeting bots, calendar integrations, and webhooks
 * OpenAPI spec version: 2.0.0
 */

/**
 * The current status of the bot
 */
export type GetBotStatusResponseDataStatus =
  (typeof GetBotStatusResponseDataStatus)[keyof typeof GetBotStatusResponseDataStatus]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetBotStatusResponseDataStatus = {
  queued: "queued",
  pickup_delayed: "pickup_delayed",
  awaiting_reconciliation: "awaiting_reconciliation",
  transcribing: "transcribing",
  completed: "completed",
  failed: "failed",
  transcription_failed: "transcription_failed",
  joining_call: "joining_call",
  in_waiting_room: "in_waiting_room",
  in_waiting_for_host: "in_waiting_for_host",
  in_call_not_recording: "in_call_not_recording",
  in_call_recording: "in_call_recording",
  recording_paused: "recording_paused",
  recording_resumed: "recording_resumed",
  call_ended: "call_ended",
  recording_succeeded: "recording_succeeded",
  recording_failed: "recording_failed",
  api_request_stop: "api_request_stop",
  bot_rejected: "bot_rejected",
  bot_removed: "bot_removed",
  bot_removed_too_early: "bot_removed_too_early",
  waiting_room_timeout: "waiting_room_timeout",
  invalid_meeting_url: "invalid_meeting_url",
  meeting_error: "meeting_error",
  MEET_LOGIN_UNAVAILABLE: "MEET_LOGIN_UNAVAILABLE",
  MEET_LOGIN_REQUIRED: "MEET_LOGIN_REQUIRED",
  MEET_LOGIN_FAILED_SAML_REJECTED: "MEET_LOGIN_FAILED_SAML_REJECTED",
  MEET_LOGIN_FAILED_TIMEOUT: "MEET_LOGIN_FAILED_TIMEOUT"
} as const
